import { render, staticRenderFns } from "./msgDetaile.vue?vue&type=template&id=afb276f2&scoped=true"
import script from "./msgDetaile.vue?vue&type=script&lang=js"
export * from "./msgDetaile.vue?vue&type=script&lang=js"
import style0 from "./msgDetaile.vue?vue&type=style&index=0&id=afb276f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb276f2",
  null
  
)

export default component.exports